import React, { useEffect, useState } from 'react';
import { Paper, Skeleton, Grid, Tooltip } from '@mui/material';
import InterpreterModeIcon from '@mui/icons-material/InterpreterMode';
// import { getRatio } from 'api/sentinelAPI';
import { useSelector } from 'react-redux';
import GroupIcon from '@mui/icons-material/Group';
import { useTheme } from '@mui/material/styles';
import NoDataImg from '../../../assets/images/No_data-amico.svg';
// import { customerAssociateRatio, interactionNumbers } from 'api/sentinelAPI';
import dummydata from './data.json'; // Adjust path accordingly
import { getGenderAgeDistribution, getUniqueWalkinWalkout } from 'api';

function Rightbar() {
  // const [cusAssRatio, setCusAssRatio] = useState(false);
  const [cusAssRatioData, setCusAssRatioData] = useState(false);
  const [attended, setAttended] = useState('NA');
  const [unAttended, setUnAttended] = useState(false);
  const [interactionData, setInteractionData] = useState(false);
  const [maleData, setMaleData] = useState(false);
  const [femaleData, setFemaleData] = useState(false);
  const [totalMale, setTotalMale] = useState(false);
  const [totalFemale, setTotalFemale] = useState(false);
  const theme = useTheme();
  const date = useSelector((state) => state.customization.currentDate);

  const selectedTime = useSelector((state) => state.customization.selectedTime);
  const startTime = new Date(selectedTime.start_time);
  const endTime = new Date(selectedTime.end_time);

  const formattedStartTimeIST = startTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }).split(',')[1];
  const formattedEndTimeIST = endTime.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }).split(',')[1];

  const [isMounted, setIsMounted] = useState(false);

  async function getCustomerAssociateRatio(commonBody, signal) {
    try {
      const data = dummydata.customerAssociateRatio;

      if (!signal.aborted) {
        if (!data || data.length === 0) {
          // setCusAssRatio(false);
          setCusAssRatioData(false);
        } else if (data && data.length > 0) {
          // const cusCounts = data.map((obj) => obj.customer_count);
          // const totalCus = cusCounts.reduce((acc, val) => acc + val, 0);
          // const empCounts = data.map((obj) => obj.employee_count);
          // const totalEmp = empCounts.reduce((acc, val) => acc + val, 0);
          // const avgRatio = (totalCus / totalEmp).toFixed(2);
          // const avgRatio = data.result;
          const countData = data;
          // setCusAssRatio(avgRatio);
          setCusAssRatioData(countData);
        }
      }
    } catch (error) {
      if (!signal.aborted) {
        // setCusAssRatio(false);
        setCusAssRatioData(false);
        console.log(error);
      }
    }
  }
  // async function getAgeGenderRatio(commonBody, signal) {
  //   try {
  //     const data = dummydata.ageGender;

  //     if (!signal.aborted) {
  //       if (!data || Object.keys(data).length === 0) {
  //         setMaleData(false);
  //         setFemaleData(false);
  //         setTotalMale(0);
  //         setTotalFemale(0);
  //       } else {
  //         const totalMale = Object.values(data.male).reduce((acc, val) => acc + val, 0);
  //         const totalFemale = Object.values(data.female).reduce((acc, val) => acc + val, 0);

  //         setMaleData(data.male);
  //         setFemaleData(data.female);
  //         setTotalMale(totalMale);
  //         setTotalFemale(totalFemale);
  //       }
  //     }
  //   } catch (error) {
  //     if (!signal.aborted) {
  //       setMaleData(false);
  //       setFemaleData(false);
  //       setTotalMale(0);
  //       setTotalFemale(0);
  //       console.log(error);
  //     }
  //   }
  // }
  async function getAgeGenderRatio(commonBody, signal) {
    try {
      const requestData = { date: commonBody, source_id: 'dombivli' };
      const response = await getGenderAgeDistribution(requestData);

      if (!signal.aborted) {
        const data = response?.data.data || {};

        if (!data.male || !data.female || Object.keys(data).length === 0) {
          setMaleData(false);
          setFemaleData(false);
          setTotalMale(0);
          setTotalFemale(0);
        } else {
          // 🔥 Ensure all age groups exist in the response
          const defaultGroups = { kid: 0, teenager: 0, adult: 0, older: 0 };

          const maleData = { ...defaultGroups, ...data.male };
          const femaleData = { ...defaultGroups, ...data.female };

          // 🔥 Calculate total counts
          const totalMale = Object.values(maleData).reduce((acc, val) => acc + val, 0);
          const totalFemale = Object.values(femaleData).reduce((acc, val) => acc + val, 0);

          // ✅ Ensure state updates correctly
          setMaleData({ ...maleData });
          setFemaleData({ ...femaleData });
          setTotalMale(totalMale);
          setTotalFemale(totalFemale);
        }
      }
    } catch (error) {
      if (!signal.aborted) {
        setMaleData(false);
        setFemaleData(false);
        setTotalMale(0);
        setTotalFemale(0);
        console.log('Error fetching gender-age distribution:', error);
      }
    }
  }

  // async function getInteractionNumbers(commonBody, signal) {
  //   try {
  //     const data = dummydata.avgWaitingNull;

  //     if (!signal.aborted) {
  //       if (!data || data.length === 0) {
  //         setAttended(false);
  //         setUnAttended(false);
  //         setInteractionData(false);
  //       } else if (data && data.length > 0) {
  //         const attendedValues = data.map((obj) => obj.interacted); ///
  //         const attendedSum = attendedValues.reduce((acc, val) => acc + val, 0);
  //         const unAttendedValues = data.map((obj) => obj.not_interacted);
  //         const unAttendedSum = unAttendedValues.reduce((acc, val) => acc + val, 0);
  //         // const avgTime = sum / attendedValues.length;
  //         // const avgRatio = data.result;
  //         const zoneWise = data;
  //         setAttended(attendedSum);
  //         setUnAttended(unAttendedSum);
  //         setInteractionData(zoneWise);
  //       }
  //       // console.log('Avg Waiting Time', data);
  //     }
  //   } catch (error) {
  //     if (!signal.aborted) {
  //       setAttended(false);
  //       setUnAttended(false);
  //       setInteractionData(false);
  //       console.log(error);
  //     }
  //   }
  // }
  async function getInteractionNumbers(commonBody, signal) {
    try {
      const requestData = { date: commonBody, source_id: 'dombivli' };
      const response = await getUniqueWalkinWalkout(requestData);
      const data = response.data.data[0]?.footfall; // Extract footfall data

      if (!signal.aborted) {
        if (!data || !data.zoneFootfall || data.zoneFootfall.length === 0) {
          setAttended(0);
          setUnAttended(0);
          setInteractionData([]);
        } else {
          // Extract store-level data
          const totalAttended = data.total_attended;
          // const totalFootfall = data.store_footfall;
          const totalUnAttended = data.total_unattended;
          // Extract zone-wise data
          const zoneWise = data.zoneFootfall.map((zone) => ({
            _id: zone.zone_name, // Change from zone_name to _id to match UI
            footfall: zone.footfall,
            interacted: zone.footfall === 0 ? 0 : zone.attended, // Change attended → interacted
            not_interacted: zone.footfall === 0 ? 0 : zone.footfall - zone.attended // Compute not_interacted
          }));
          console.log('zoneWise is', zoneWise, totalAttended, totalUnAttended);
          // Update state
          setAttended(totalAttended);
          setUnAttended(totalUnAttended);
          setInteractionData(zoneWise);
        }
      }
    } catch (error) {
      if (!signal.aborted) {
        setAttended(0);
        setUnAttended(0);
        setInteractionData([]);
        console.log('Error fetching interaction numbers:', error);
      }
    }
  }

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    if (isMounted) {
      const commonBody = {
        start_time: formattedStartTimeIST,
        end_time: formattedEndTimeIST,
        start_date: date,
        storeId: '65c5e26a0b5be5dc7af327dc'
      };

      const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
      };

      const formattedDate = formatDate(date);

      getCustomerAssociateRatio(commonBody, signal);
      getInteractionNumbers(formattedDate, signal);
      getAgeGenderRatio(formattedDate, signal);
    }

    return () => {
      abortController.abort();
    };
  }, [date, isMounted, formattedStartTimeIST, formattedEndTimeIST]);

  cusAssRatioData && cusAssRatioData.sort((a, b) => b.customer_count / b.employee_count - a.customer_count / a.employee_count);
  interactionData && interactionData.sort((a, b) => a.interacted - b.interacted);

  const paperStyle = {
    width: '100%',
    maxHeight: '280px',
    height: '280px',
    padding: '10px',
    marginBottom: '11.5px',
    position: 'relative',
    left: 'auto',
    borderRadius: '15px',
    display: 'flex',
    alignItems: 'center',
    flex: '1'
  };

  const paperStyleLastCard = {
    width: '100%',
    maxHeight: '300px',
    height: '300px',
    padding: '10px',
    marginBottom: '11.5px',
    position: 'relative',
    left: 'auto',
    borderRadius: '15px',
    display: 'flex',
    // alignItems: 'center',
    flex: '1'
  };

  return (
    <>
      <Grid
        item
        xs={12}
        // md={3}
        // sm={6}
        sx={{
          width: '100%',
          // height:'100px',
          mb: -1,
          mt: 1,
          paddingTop: '8px',
          [theme.breakpoints.up('sm')]: {
            mb: -1,
            mt: 1 // Height for screens equal to or larger than 'md' breakpoint
          },
          [theme.breakpoints.up('md')]: {
            mb: -1,
            mt: -1 // Height for screens equal to or larger than 'md' breakpoint
          }
        }}
      >
        {/* <Paper elevation={3} sx={paperStyle}>
          {cusAssRatioData && cusAssRatioData.length > 0 ? (
            <div className="flex  w-full  flex-col gap-1">
              <div className="flex items-center justify-center gap-2 w-full">
                {cusAssRatioData ? (
                  <GroupIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                ) : (
                  <Skeleton variant="circular" width={60} height={45} />
                )}
                <div className="w-full">
                  {cusAssRatioData ? (
                    <p className="text-3xl">1 : {cusAssRatio}</p>
                  ) : (
                    <Skeleton variant="rectangular" className="mb-3 rounded-sm" width={50} height={20} />
                  )}

                  {cusAssRatioData ? (
                    <p>
                      <span className="text-[1.090rem]">Employee : Customer</span>
                    </p>
                  ) : (
                    <Skeleton variant="rectangular" width={150} height={15} className=" mb-2 rounded-sm" />
                  )}
                </div>
              </div>
              {cusAssRatioData ? (
                <div className=" bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                  {cusAssRatioData.map((item, index) => {
                    const highestFootfall = cusAssRatioData.reduce((maxFootfall, item) => {
                      return item.customer_count / item.employee_count > maxFootfall
                        ? item.customer_count / item.employee_count
                        : maxFootfall;
                    }, 0);
                    const percentage = ((item.customer_count / item.employee_count / highestFootfall) * 100).toFixed(1);
                    const barcolor = percentage >= 80 ? '#ff413a' : percentage >= 50 ? '#f4a100' : '#00AC69';
                    return (
                      <div className="mt-2" key={index}>
                        <div className="flex gap-1 items-center">
                          <div
                            className=" rounded-full h-4 w-4"
                            style={{
                              // backgroundColor: ${item.zoneColourHex}
                              backgroundColor: '#2D9BBC'
                            }}
                          >
                            {' '}
                          </div>
                          <div>
                            {item._id} - 1 : {(item.customer_count / item.employee_count).toFixed(2)}
                          </div>
                        </div>
                        <LinearProgress
                          variant="determinate"
                          value={parseInt(percentage)}
                          sx={{
                            marginTop: '5px',
                            backgroundColor: 'rgb(241 245 249)', // Set color for unfilled part
                            '& .MuiLinearProgress-bar': {
                              backgroundColor: `${barcolor}` // Set color for filled part
                            }
                          }}
                        />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <Skeleton variant="rectangular" height={184} className="rounded-md" />
              )}
            </div>
          ) : (
            <img style={{ height: '392px' }} src={NoDataImg} alt="No data" />
          )}
        </Paper> */}
        <Paper elevation={3} sx={paperStyle}>
          {maleData && femaleData ? (
            <div className="flex w-full flex-col gap-1">
              <div className="flex items-center justify-center gap-2 w-full">
                <GroupIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                <div className="w-full">
                  <p className="text-xl">Demographics Analytics</p>
                </div>
              </div>
              <div className="bg-slate-100 flex-grow overflow-y-auto h-[200px] p-2 rounded-lg scrollbar">
                <p className="text-xl font-semibold text-[#44BE54] mb-1">Male: {totalMale}</p>
                <div className="flex w-full h-6 bg-gray-300 rounded-full overflow-hidden">
                  {['kid', 'young', 'adult', 'old'].map((ageGroup, index) => {
                    const width = totalMale ? (maleData[ageGroup] / totalMale) * 100 : 0;
                    const colors = ['#A8E4B1', '#76D183', '#44BE54', '#247331'];
                    return (
                      <Tooltip
                        key={ageGroup}
                        title={<span className="text-lg p-2">{`${ageGroup}: ${maleData[ageGroup]}`}</span>}
                        arrow
                        PopperProps={{
                          modifiers: [{ name: 'preventOverflow', enabled: true }]
                        }}
                        sx={{ fontSize: '1.2rem', padding: '8px' }}
                      >
                        <div
                          className="h-full"
                          style={{
                            width: `${width}%`,
                            backgroundColor: colors[index]
                          }}
                        ></div>
                      </Tooltip>
                    );
                  })}
                </div>

                {/* Male Legend */}
                <div className="flex justify-center gap-4 mt-2">
                  {['kid', 'young', 'adult', 'old'].map((ageGroup, index) => {
                    const colors = ['#A8E4B1', '#76D183', '#44BE54', '#247331'];
                    return (
                      <div key={ageGroup} className="flex items-center gap-2">
                        <div className="w-4 h-4 rounded-full" style={{ backgroundColor: colors[index] }}></div>
                        <p className="text-sm">{ageGroup}</p>
                      </div>
                    );
                  })}
                </div>

                <p className="text-xl font-semibold text-[#FB1751] mt-3 mb-1">Female: {totalFemale}</p>
                <div className="flex w-full h-6 bg-gray-300 rounded-full overflow-hidden">
                  {['kid', 'young', 'adult', 'old'].map((ageGroup, index) => {
                    const width = totalFemale ? (femaleData[ageGroup] / totalFemale) * 100 : 0;
                    const colors = ['#FD9DB5', '#FC5A83', '#FB1751', '#C2043A']; // ✅ Shades of pink
                    return (
                      <Tooltip
                        key={ageGroup}
                        title={<span className="text-lg p-2">{`${ageGroup}: ${femaleData[ageGroup]}`}</span>}
                        arrow
                        PopperProps={{
                          modifiers: [{ name: 'preventOverflow', enabled: true }]
                        }}
                        sx={{ fontSize: '1.2rem', padding: '8px' }}
                      >
                        <div
                          className="h-full"
                          style={{
                            width: `${width}%`,
                            backgroundColor: colors[index]
                          }}
                        ></div>
                      </Tooltip>
                    );
                  })}
                </div>

                {/* Female Legend */}
                <div className="flex justify-center gap-4 mt-2">
                  {['kid', 'young', 'adult', 'old'].map((ageGroup, index) => {
                    const colors = ['#FD9DB5', '#FC5A83', '#FB1751', '#C2043A'];
                    return (
                      <div key={ageGroup} className="flex items-center gap-2">
                        <div className="w-4 h-4 rounded-full" style={{ backgroundColor: colors[index] }}></div>
                        <p className="text-sm">{ageGroup}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : (
            <img style={{ height: '392px' }} src={NoDataImg} alt="No data" />
          )}
        </Paper>

        <Paper elevation={3} sx={paperStyleLastCard}>
          {interactionData && interactionData.length > 0 ? (
            <div className="flex  w-full  flex-col gap-1">
              <div className="flex items-center justify-center gap-2 w-full">
                {attended != 'NA' ? (
                  <InterpreterModeIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                ) : (
                  <Skeleton variant="circular" width={60} height={45} />
                )}
                <div className="w-full">
                  {attended != 'NA' ? (
                    <div className="w-full flex space-x-1">
                      <div className="w-1/2 flex flex-col text-center  rounded-md shadow-md bg-[#44BE54] drop-shadow-md text-white">
                        <span>Attended</span>
                        <span className="text-2xl">{attended}</span>
                      </div>
                      <div className="w-1/2 flex flex-col text-center bg-[#FB1751] rounded-md shadow-md drop-shadow-md text-white">
                        <span>Unattended</span>
                        <span className="text-2xl">{unAttended}</span>
                      </div>
                    </div>
                  ) : (
                    <Skeleton variant="rectangular" className="mb-3 rounded-sm" width={50} height={20} />
                  )}

                  {attended != 'NA' ? (
                    <p className="text-lg">Interactions</p>
                  ) : (
                    <Skeleton variant="rectangular" width={150} height={15} className=" mb-2 rounded-sm" />
                  )}
                </div>
              </div>
              {attended != 'NA' ? (
                <div className=" bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                  {interactionData.map((item, index) => {
                    return (
                      <div className="mt-2" key={index}>
                        <div className="flex gap-1 items-center">
                          <div
                            className=" rounded-full h-4 w-4"
                            style={{
                              backgroundColor: '#2D9BBC'
                            }}
                          >
                            {' '}
                          </div>
                          <div className="flex items-center gap-2">
                            <span className="mt-0.5">{item._id} : </span>
                            <div className="h-6  text-center px-2 border border-[#44BE54] shadow-md rounded-md text-[#44BE54] drop-shadow-md">
                              {item.interacted}
                            </div>
                            {item.not_interacted > 0 && (
                              <div className="h-6  border border-[#FB1751] text-[#FB1751] text-center px-2 shadow-md rounded-md drop-shadow-md">
                                {item.not_interacted}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <Skeleton variant="rectangular" height={184} className="rounded-md" />
              )}
            </div>
          ) : (
            <img style={{ height: '392px' }} src={NoDataImg} alt="No data" />
          )}
        </Paper>
      </Grid>

      {/* <div className="opacity-30">
        <Card
          sx={{
            marginTop: '0.5rem',
            padding: '0.5rem',
            borderRadius: '12px 12px 0 0'
          }}
        >
          <div
            style={{
              padding: '10px',
              textAlign: 'center',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem'
            }}
          >
            <QuestionAnswerIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
            <div className="flex flex-col items-start pt-1">
              <h3 className="text-4xl">12</h3>
              <p>Message Logs</p>
            </div>
          </div>
        </Card>
        <Card sx={{ marginTop: '2px', padding: '0.5rem', borderRadius: '2px' }}>
          <div className="flex gap-3 mb-1">
            <AccountCircleIcon className="bg-[#444444] text-white rounded-full p-1 text-3xl" />
            <div className="flex flex-col gap-2">
              <div>has not interacted with a customer over 15 mins.</div>
              <div className="text-blue-500 cursor-pointer font-bold">View {'->'}</div>
            </div>
          </div>
          <div
            style={{
              textAlign: 'right'
            }}
          >
            08:02:53 30-01-2024
          </div>
        </Card>
        <Card sx={{ marginTop: '2px', padding: '0.5rem', borderRadius: '2px' }}>
          <div className="flex gap-3 mb-1">
            <AccountCircleIcon className="bg-[#444444] text-white rounded-full p-1 text-3xl" />
            <div className="flex flex-col gap-2">
              <div>
                Heavy customer traffic detected at Phone zone. Please re-assign <span className="font-bold">Ritesh Kumar</span> to Phones
                zone for optimal customer - employee ratio.
              </div>
              <div className="text-blue-500 cursor-pointer font-bold">View {'->'}</div>
            </div>
          </div>
          <div
            style={{
              textAlign: 'right'
            }}
          >
            08:02:53 30-01-2024
          </div>
        </Card>
        <Card sx={{ marginTop: '2px', padding: '0.5rem', borderRadius: '0 0 12px 12px' }}>
          <div className="flex gap-3 mb-1 ">
            <AccountCircleIcon className="bg-[#444444] text-white rounded-full p-1 text-3xl" />
            <div className="flex flex-col gap-2">
              <div>Loyal customer 3330123 detected at entry gate.</div>
              <div className="text-blue-500 cursor-pointer font-bold">View {'->'}</div>
            </div>
          </div>
          <div
            style={{
              textAlign: 'right'
            }}
          >
            <p>08:02:53 30-01-2024</p>
          </div>
        </Card>
      </div> */}
    </>
  );
}

export default Rightbar;
